import DeleteConfirmation from "../components/ui/DeleteConfirmation";
import { helpers } from "./helpers";

export const deleteConfirmation = {
    components: { DeleteConfirmation },
    data() {
        return {
            deleteConfirmationVisible: false,
            deletePayload: {},
            deleteConfirmationIcon: "",
            deleteConfirmationTitle: "",
            deleteConfirmationDescription: "",
            deleteConfirmationButtonText: "",
        };
    },
    methods: {
        promptDelete(payload) {
            this.deletePayload = { ...payload };
            this.deleteConfirmationVisible = true;
        },

        resetDelete() {
            if (helpers.isSpinnerActive("confirm-delete-button")) {
                helpers.toggleSpinner("confirm-delete-button");
            }
            this.deleteConfirmationButtonText = "";
            this.deleteConfirmationVisible = false;
            this.deletePayload = {};
        },
    },
};
